import { Navigate, useParams } from 'react-router-dom';
import { ProfileHub } from './components/ProfileHub';
import { isProfileSectionId } from './data';

const ProfilePage = () => {
  const { section } = useParams();
  if (!isProfileSectionId(section)) {
    return <Navigate to="/app/profile/account" replace />;
  }
  return <ProfileHub sectionId={section} />;
};

export default ProfilePage;
